import { employeeService } from '@/services/userService/EmployeeService';
import {
  facilityFeatureFlagsNavigationItem
} from '@/vues/components/shiftkey/pages/settings/facilityFeatureFlags/FacilityFeatureFlagsNavigationConfigs';

const settingsItems = [
  {
    title: 'Specialties',
    url: '/settings/specialties',
  },
  {
    title: 'Skills',
    url: '/settings/skills',
  },
  {
    title: 'Credentials',
    url: '/settings/credentials/all',
  },
  {
    title: 'Regions',
    url: '/settings/regions',
  },
  {
    title: 'Marketers',
    url: '/settings/marketers',
  },
  {
    title: 'Payout Deductions',
    url: '/settings/payout_deductions/',
  },
];

if (employeeService.canViewSettingsFacilityFeatureFlags()) {
  settingsItems.push(facilityFeatureFlagsNavigationItem);
}

if (employeeService.canManageEmployeePermissions()) {
  settingsItems.push({
    title: 'Roles',
    url: '/settings/roles',
  });
}

export default [
  {
    action: 'far fa-calendar-alt',
    title: 'Schedule',
    url: '/schedule',
  },
  {
    action: 'fas fa-user',
    title: 'Users',
    items: [
      {
        title: 'Providers',
        url: '/users/providers',
      },
      {
        title: 'Clients',
        url: '/users/clients',
      },
      {
        title: 'Employees',
        url: '/users/employees',
      },
      {
        title: 'On-Boarding',
        url: '/users/onboarding',
      },
    ],
  },
  {
    action: 'fas fa-users',
    title: 'Teams',
    url: '/teams',
  },
  {
    action: 'far fa-hospital',
    title: 'Facilities',
    url: '/facilities',
  },
  {
    action: 'fas fa-user-clock',
    title: 'Shifts',
    items: [
      {
        title: 'Shifts Report',
        url: '/shifts/report',
      },
      {
        title: 'Requested Shifts',
        url: '/shifts/requested_shifts',
      },
      {
        title: 'Timesheets',
        url: '/shifts/timesheets',
      },
      {
        title: 'Provider Invoices',
        url: '/provider_digital_invoice',
      },
    ],
  },
  {
    action: 'fas fa-university',
    title: 'Payables',
    items: [
      {
        title: 'Unpaid',
        url: '/payables/unpaid',
      },
      {
        title: 'Paid',
        url: '/payables/paid',
      },
      {
        title: 'Credits',
        url: '/payables/credits',
      },
      {
        title: 'Deductions',
        url: '/payables/provider_deductions',
      },
    ],
  },
  {
    action: 'fa fa-file-invoice',
    title: 'Billing',
    items: [
      {
        title: 'Invoices',
        url: '/billing/invoices',
      },
      {
        title: 'Credits',
        url: '/billing/credits',
      },
      {
        title: 'Charges',
        url: '/billing/charges',
      },
    ],
  },
  {
    action: 'fa-crosshairs',
    title: 'Insights',
    items: [
      {
        title: 'Hours',
        url: '/insights/hours',
      },
      {
        title: 'Regions',
        url: '/insights/regions',
      },
      {
        title: 'Onboarding',
        url: '/insights/onboarding',
      },
      {
        title: 'Credit Limits',
        url: '/insights/credit-limits',
      },
      {
        title: 'Facility Map',
        url: '/insights/facility-map',
      },
      {
        title: 'Scheduled Hours',
        url: '/insights/s-hours',
      },
      {
        title: 'Messaging',
        url: '/insights/messaging',
      },
      {
        title: 'Resolutions',
        url: '/insights/resolutions',
      },
      {
        title: 'Validation',
        url: '/insights/credential-validation',
      },
    ],
  },
  {
    action: 'fas fa-hands-helping',
    title: 'Help',
    items: [
      {
        title: 'Help Center',
        url: import.meta.env.VITE_SHIFTKEY_HELP_LINK,
        blank: true,
        useRouter: false,
      },
    ],
  },
  {
    action: 'fas fa-cloud-download-alt',
    title: 'Downloads',
    url: '/downloads',
  },
  {
    action: 'fas fa-envelope',
    title: 'Messaging',
    url: '/messaging',
  },
  {
    action: 'fas fa-cogs',
    title: 'Settings',
    items: settingsItems,
  },
  {
    action: 'account_circle',
    title: 'Account',
    items: [
      {
        title: 'Logout',
        url: '/auth/logout',
      },
    ],
  },
];
